<template>
    <el-select :placeholder="placeholder"
                v-model="selected_company"
                class="no-select w-full"
                filterable
                remote
                :disabled="disabled"
                :remote-method="fetchCompany"
                :loading="is_fetching_company"
                @change="changeTargetCompany"
                clearable>
        <el-option
            v-for="company in companiesAlphabeticalOrder"
            class="p-0"
            :key="company.id"
            :label="company.name"
            :value="company.id">
            <div>
                <div>
                    <p class="mb-0">{{ company.name }}</p>
                </div>
            </div>
        </el-option>
    </el-select>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Select a company'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        except: {
           required: false,
           type: Array,
            default: () => []
        },
        acceptSid: {
            type: Boolean,
            required: false,
            default: false
        },
        filters: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            selected_company: null,
            companies: [],
            is_fetching_company: false,
            CancelToken: null,
            source: null,
        }
    },

    watch: {
        value(val) {
            this.selected_company = val
        }
    },

    computed: {
        companiesAlphabeticalOrder() {
            if (this.companies.length) {
                let companies = this.except.length > 0 ? _.clone(this.companiesExceptExcluded) : _.clone(this.companies)
                return companies.sort((a, b) => {
                    let textA = a.name.toUpperCase()
                    let textB = b.name.toUpperCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                })
            }

            return []
        },

        companiesExceptExcluded() {
            return this.companies.filter(c => !this.except.includes(c.id))
        }
    },

    created() {
        this.CancelToken = axios.CancelToken
        this.source = this.CancelToken.source()
    },

    methods: {
        fetchCompany(query) {
            if (Number.isInteger(parseInt(query)) || query.length >= 3) {
                this.source.cancel('fetchCompany canceled by the user.')
                this.source = this.CancelToken.source()
                this.is_fetching_company = true
                const params = {
                    search_text: query,
                    ...this.filters
                }
                axios.get('/api/admin/company', {
                    params: params,
                    cancelToken: this.source.token
                }).then((res) => {
                    this.is_fetching_company = false
                    this.companies = res.data
                    if (this.acceptSid) {
                        this.addSidToCompanies(query)
                    }
                }).catch((err) => {
                    if (axios.isCancel(err)) {
                        console.log('Request canceled', err.message)
                    } else {
                        this.$root.handleErrors(err.response)
                        this.is_fetching_company = false
                    }
                    if (this.acceptSid) {
                        this.addSidToCompanies(query)
                    }
                })
            } else {
                this.companies = []
            }
        },

        addSidToCompanies(sid) {
            // add searched text as sid to the list
            this.companies.unshift({
                id: "sid:" + sid,
                name: "SID: " + sid
            })
        },

        changeTargetCompany(company_id) {
            this.$emit('input', company_id)

            const company = this.companies.find(company => parseInt(company.id) === parseInt(company_id))

            if (company) {
                this.$emit('company-selected', company)
            }
        },

        searchCompanies(query) {
            // Add the filters to your API request
            const params = {
                search: query,
                ...this.filters
            }

            return axios.get('/api/admin/companies', { params })
                .then(response => {
                    return response.data
                })
        }
    }
}
</script>
